export enum EQUERY_KEY {
  MY_INFO = 'my-info',
  MY_USERS = 'my-users',
  MY_SHELF = 'my-shelf',
  // MY_SHELF_BOOKMARK = 'my-shelf-bookmark',
  // MY_SHELF_UNREAD = 'my-shelf-unread',
  // MY_SHELF_TRASH = 'my-shelf-trash',
  MY_SUBSCRIPTION = 'my-subscription',

  CATEGORIES = 'categories',
  PROVIDERS = 'providers',
  ARTICLES = 'articles',
  ARTICLE = 'article',
}
